import {
  HttpContext,
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoaderService } from './service/loader.service';

export const NO_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

export type LoaderOptions = { noGlobalLoader?: boolean };

export function loaderContext(options?: LoaderOptions) {
  return options?.noGlobalLoader ? { context: new HttpContext().set(NO_GLOBAL_LOADER, true) } : {};
}

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(
    private loaderService: LoaderService,
    private router: Router
  ) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const excludeUrls = [
      'compass/check-stato-simulazione',
      'common/system/check',
      'servizi-ris/track-magazine-permanence',
      'dls/community/messaggi/vota',
      'dls/community/thread/cerca',
      'dls/community/thread/lista/recenti',
      'dls/community/thread/lista/seguiti',
      'dls/community/config/faq',
      'dls/community/config/nuovo-messaggio',
      'dls/community/tag/lista-popolari',
      'dls/community/tag/cerca',
      'dls/community/tag/autocomplete',
      'dls/community/categorie/lista-breve',
      'dls/contenuti',
      'dls/webinar/live-video',
      'magazzino/lista',
      'magazzino/parse-code-udi',
      'prontuario/lista-pg',
      'prontuario/cerca-farmaco-pg',
      'supporto/lista-ticket',
      'contenuti/list',
      'abbonamento/fatture',
      'dls/compilazioni',
      'compilazioni',
      'npp/consulenza/conversazioni'
    ];
    const urlSegment = (req.url.match(/https?:\/\/.+?\/(.+)/) || [])[1];
    const noLoader =
      req.context.get(NO_GLOBAL_LOADER) || (urlSegment ? excludeUrls.some(url => urlSegment.startsWith(url)) : true);

    if (!noLoader) {
      this.requests.push(req);
      // console.log('No of requests--->' + this.requests.length + ' ');
      this.loaderService.isLoading.next(true);
    }
    return Observable.create(observer => {
      const subscription = next.handle(req).subscribe(
        event => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
          }
        },
        err => {
          this.removeRequest(req);
          observer.error(err);
        },
        () => {
          this.removeRequest(req);
          observer.complete();
        }
      );
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}
